<div class="container mt-4">
    <button class="btn btn-primary mb-3" (click)="addslideType()">Add Slide Type</button>

    <div class="card p-3 mb-3">
        <div class="row g-2 align-items-end">
            <div class="col-md-6">
                <label>Search</label>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Short code, name, remarks, or layout…"
                    [(ngModel)]="searchText"
                    (ngModelChange)="onSearchChange()"
                />
            </div>
            <div class="col-md-6 text-muted small">
                {{ displayedSlideTypes.length }} of {{ slideTypes.length }} slide type(s)
            </div>
        </div>
    </div>

    <table class="table table-bordered table-hover">
        <thead>
            <tr>
                <th role="button" (click)="setSort('slideTypeShortcode')">Short Code{{ sortIndicator('slideTypeShortcode') }}</th>
                <th role="button" (click)="setSort('slideTypeName')">Name{{ sortIndicator('slideTypeName') }}</th>
                <th role="button" (click)="setSort('slidetypeRemarks')">Remarks{{ sortIndicator('slidetypeRemarks') }}</th>
                <th role="button" (click)="setSort('slideLayoutShortcode')">Layout{{ sortIndicator('slideLayoutShortcode') }}</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let slideType of displayedSlideTypes">
                <td>{{ slideType.slideTypeShortcode }}</td>
                <td>{{ slideType.slideTypeName }}</td>
                <td>{{ slideType.slidetypeRemarks }}</td>
                <td>{{ slideType.slideLayoutShortcode }}</td>
                <td>
                    <button class="btn btn-secondary" (click)="editslideTypeLines(slideType)">Edit Lines</button>
                </td>
            </tr>
            <tr *ngIf="displayedSlideTypes.length === 0">
                <td colspan="5" class="text-muted text-center">No slide types match your search.</td>
            </tr>
        </tbody>
    </table>
</div>
